<template>
  <input
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :class="[
      'placeholder:text-muted-foreground border-input h-9 min-w-0 rounded-md border bg-transparent px-3 py-1 text-sm shadow-sm outline-none disabled:opacity-50',
      'focus:border-ring focus:ring-2 focus:ring-ring',
      'w-full',
      className,
    ]"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    value: { type: [String, Number], default: '' },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    className: { type: String, default: '' },
  },
}
</script>

